import { render, staticRenderFns } from "./CTAButton.vue?vue&type=template&id=4ddede95&scoped=true"
import script from "./CTAButton.vue?vue&type=script&lang=js"
export * from "./CTAButton.vue?vue&type=script&lang=js"
import style0 from "./CTAButton.vue?vue&type=style&index=0&id=4ddede95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddede95",
  null
  
)

export default component.exports